import classNames from 'classnames'
import React, { Component } from 'react';
import ContentEditable from 'react-contenteditable'
import ReactDOM from 'react-dom';
import { TOGGLE_COMMENTS_SUCCESS } from '../actionTypes'
import setFocusToEnd from '../functions/setEndOfContenteditable'
import storage from '../actions/storage'
import { guid, getArrForLightBox } from '../selectors'
import handleImageUpload from '../functions/handleImageUpload'
import { conditionCommentsTime, conditionLineUpdateTime, getCaretPos, setCaretPos, saveCaretPosition } from '../functions/snippets'
import 'rangy/lib/rangy-selectionsaverestore';


//rangy.init();


class LineEditable extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isLineNavOn: false,
            isFocusOn: false,
            isHoverOn: false,
        }
    }





    toggleLineNav = () => this.setState({ isLineNavOn: !this.state.isLineNavOn })

    onFocus = () => {
        this.setState({ isFocusOn: !this.state.isFocusOn })
        //this.focusLineInput();
        this.props.onFocus()
    };
    onBlur = () => {
        this.setState({ isFocusOn: false })
        this.props.onBlur()
    };

    focusLineInput () {
        const input = ReactDOM.findDOMNode(this.input);
        setFocusToEnd(input)
    }

    shouldComponentUpdate(nextProps, nextState) {

        return !nextState.isFocusOn
    }


    render(){

        const {
            text,
            onInput,
            onPaste,
        } = this.props;



        const handleOnInput = (e) => {
            const text = e.target.value

            onInput(text.replace(/<([^\s]+?)(\s+?[^\s]+?)*>/gi, '<$1>'))
        }


        return (
            <ContentEditable
                ref={input => this.input = input}
                onChange={ e => handleOnInput(e) }
                onFocus={ this.onFocus }
                onBlur={ this.onBlur }
                className="list__text"
                //html={linkifyHtml(text,options)}
                html={text}
                onPaste={onPaste}
            />
        )
    }
}


export default LineEditable;


// WEBPACK FOOTER //
// ./src/components/LineEditable.js